// extracted by mini-css-extract-plugin
export default {"isLoading":"hXAs9","thumbnailContainer":"tRtUI","sticky":"bO1cO","productCardContainer":"ygAVf","uppercaseTitle":"uRg24"};